import { Dialog, DialogContent } from "@/components/ui/dialog";
import { ModalHeader } from "./modal/ModalHeader";
import { InterestForm } from "./interest-form/InterestForm";
import { useInterestForm } from "./interest-form/useInterestForm";
import { translations } from "./modal/translations";
import { useLocation } from "react-router-dom";

interface InterestFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'notification' | 'partnership';
  title: string;
}

export const InterestFormModal = ({ isOpen, onClose, type, title }: InterestFormModalProps) => {
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'en';
  const t = translations[currentLang];

  const {
    name,
    setName,
    email,
    setEmail,
    message,
    setMessage,
    isSubmitting,
    validateName,
    validateEmail,
    handleSubmit,
  } = useInterestForm(onClose, type);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px] w-[95%] mx-auto bg-gradient-to-b from-white via-white/95 to-white/90 dark:from-gray-900 dark:via-gray-900/95 dark:to-gray-900/90 backdrop-blur-sm border-primary/10 p-4 sm:p-6 overflow-y-auto max-h-[90vh]">
        <ModalHeader title={title} />
        <InterestForm
          name={name}
          email={email}
          message={message}
          onNameChange={setName}
          onEmailChange={setEmail}
          onMessageChange={setMessage}
          onClose={onClose}
          isSubmitting={isSubmitting}
          validateName={validateName}
          validateEmail={validateEmail}
          translations={t}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </Dialog>
  );
};